// extracted by mini-css-extract-plugin
module.exports = {"arrowBtn":"styles_arrowBtn__gKOFY","arrowContainer":"styles_arrowContainer__x86gC"};